import React, { useCallback, useEffect, useState } from 'react';
import { array } from 'prop-types';
import { Link } from 'react-router-dom';

import LeftNavigationMenu from '../leftNavigationMenu/leftNavigationMenu';

import './_pressConcertList.scss';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import SVGLoader from '../../common/SVGLoader/SVGLoader';

const PressConcertList = ({ concerts }) => {
  const [years, setYears] = useState(null);

  const getCoords = useCallback((elem) => {
    const box = elem.getBoundingClientRect();

    const { body } = document;
    const docEl = document.documentElement;

    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const clientTop = docEl.clientTop || body.clientTop || 0;

    const top = box.top + scrollTop - clientTop;

    return { top: Math.round(top) };
  }, []);

  useEffect(() => {
    const yearValues = new Set();
    concerts && concerts.map((year) => yearValues.add(year.year));
    const finalYears = [];
    yearValues.forEach((year) => finalYears.push(year));
    setYears(finalYears);
  }, [concerts]);

  const leftMenuData =
    years && years.map((item) => ({ type: `pressList${item}` }));
  leftMenuData && leftMenuData.push({ type: 'pressListAccreditation' });

  return (
    <section className='faq_list press_list'>
      <LeftNavigationMenu getCoords={getCoords} data={leftMenuData} top={0} />

      <div className='faqListing pressListing'>
        <h3 className='pressListTitle'>Concerts</h3>
        <p className='pressListSubtitle'>Photo bank</p>
        <div>
          {years &&
            years.map((e) => {
              return (
                <div className='pressItem' id={`pressList${e}`} key={e}>
                  <h3 className='yearTitle'>{e}</h3>
                  <div className='pressItemsSection'>
                    {concerts &&
                      concerts.map(
                        (concert, i) =>
                          concert.year === e && (
                            <Link
                              to={`/press/${concert.id}/media_all`}
                              className='pressListItem'
                            >
                              <LazyLoadComponent
                                placeholder={
                                  <SVGLoader style={{ paddingTop: '69%' }} />
                                }
                              >
                                <div
                                  className='mainThumb'
                                  style={{
                                    backgroundImage: `url('${concert.data[0].image}')`,
                                  }}
                                />
                              </LazyLoadComponent>
                              <div className='buttonDiv'>
                                <button className='viewGalleryBtn'>
                                  View Gallery
                                </button>
                              </div>
                              <p
                                className='itemTitle'
                                dangerouslySetInnerHTML={{
                                  __html: concert.title,
                                }}
                              />
                            </Link>
                          )
                      )}
                  </div>
                </div>
              );
            })}
        </div>
        <div className='fillTheForm' id='pressListAccreditation'>
          <h3>Want to get accredited?</h3>
          <Link to='/press_form'>Fill in the form!</Link>
        </div>
      </div>
    </section>
  );
};

PressConcertList.propTypes = {
  concerts: array.isRequired,
};

export default PressConcertList;
